import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { PendingPaymentInfo } from '@cms-max/medicare-api-sdk'
import { Card } from '@cmsgov/ds-medicare-gov'

import classes from './OnlinePaymentCard.module.scss'

type OnlinePaymentCardProps = {
  className?: string
  onlinePayment: PendingPaymentInfo
}
export function OnlinePaymentCard ({ className, onlinePayment }: OnlinePaymentCardProps) {
  const { t } = useTranslation('premiumsHistory')
  const dateFormatOptions: Intl.DateTimeFormatOptions = {
    hour12: true,
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }

  const formattedDate = new Date(onlinePayment.submittedDateTime || '').toLocaleString('en-US', dateFormatOptions).replace(',', '')
  const total = onlinePayment.total.toFixed(2).toString()
  let paymentMethod

  if (onlinePayment.paymentMethodType === 'ACH') {
    paymentMethod = t('paymentMethods.ach')
  } else if (onlinePayment.paymentMethodType === 'CREDIT_OR_DEBIT_MEDICARE_GOV') {
    paymentMethod = t('paymentMethods.creditOrDebit')
  } else {
    paymentMethod = ''
  }

  const mobileClasses = window.innerWidth < 420 ? 'ds-u-word-break' : ''

  return (
    <Card className={classNames('ds-u-padding-x--3', className)}>
      <div data-testid='online-payment-card'>
        <dl className='ds-l-row'>
          <div className='ds-l-col--12 ds-l-lg-col--2 ds-l-md-col--6 ds-u-padding-y--1'>
            <dt>{t('onlinePayments.postDate')}</dt>
            <dd className='ds-u-margin--0 ds-text-body--lg ds-u-font-weight--semibold'>{formattedDate}</dd>
          </div>

          <div className={classNames('ds-l-col--12', 'ds-l-lg-col--4', 'ds-l-md-col--6', 'ds-u-margin-y--1', mobileClasses)}>
            <dt>{t('onlinePayments.confirmationNumber')}</dt>
            <dd className='ds-u-margin--0 ds-text-body--lg ds-u-font-weight--semibold'>{onlinePayment.agencyTrackingId}</dd>
          </div>

          <div className='ds-l-col--12 ds-l-lg-col--3 ds-l-md-col--6 ds-u-padding-y--1 ds-u-word-break'>
            <dt>{t('onlinePayments.paymentMethod')}</dt>
            <dd className='ds-u-margin--0 ds-text-body--lg ds-u-font-weight--semibold'>{paymentMethod}</dd>
          </div>

          <div className={classNames('ds-u-padding-y--2', 'ds-u-margin-y--1', classes.totalAmount)}>
            <dt>{t('onlinePayments.amountPosted')}</dt>
            <dd className='ds-u-margin--0 ds-text-body--lg'>${total}</dd>
          </div>
        </dl>
      </div>
    </Card>
  )
}

export default OnlinePaymentCard
